import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { formatNumber } from "../../../utils/formatNumber";

const numberValue = (value) => Number(value ?? 0) || 0;

export default function SaleInsuranceExtraPriceModal({
  open,
  onClose,
  item,
  onSave,
}) {
  const details = useMemo(() => {
    const totalWeight = numberValue(item?.originalItem?.netWeight ?? item?.usedWeight);
    const insuranceRows = (item?.details || []).filter(
      (detail) => detail?.priceSource === "insurance",
    );
    const protectedWeight = insuranceRows.reduce(
      (sum, detail) => sum + numberValue(detail.usedWeight),
      0,
    );
    const protectedTotal = insuranceRows.reduce(
      (sum, detail) => sum + numberValue(detail.usedWeight) * numberValue(detail.pricePerUnit),
      0,
    );
    return {
      totalWeight,
      protectedWeight,
      protectedTotal,
      extraWeight: Math.max(0, totalWeight - protectedWeight),
      savedPrice: item?.originalItem?.insuranceExtraPrice,
    };
  }, [item]);

  const [price, setPrice] = useState("");

  useEffect(() => {
    if (!open) return;
    setPrice(
      details.savedPrice == null ? "" : String(numberValue(details.savedPrice)),
    );
  }, [open, details.savedPrice]);

  const parsedPrice = Number(price);
  const valid = Number.isFinite(parsedPrice) && parsedPrice >= 0;

  const handleSave = () => {
    if (!valid || details.extraWeight <= 0) return;
    onSave?.({
      pricePerUnit: parsedPrice,
      totalWeight: details.totalWeight,
      extraWeight: details.extraWeight,
      protectedTotal: details.protectedTotal,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 900 }}>กำหนดราคาน้ำหนักส่วนเกิน</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 1, fontWeight: 700 }}>
          {item?.productName || item?.originalItem?.productName || "สินค้า"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          น้ำหนัก Lock {formatNumber(details.protectedWeight)} กก. / น้ำหนักส่วนเกิน {formatNumber(details.extraWeight)} กก.
        </Typography>
        {details.extraWeight <= 0 ? (
          <Alert severity="info">รายการนี้ไม่มีน้ำหนักส่วนเกินให้กำหนดราคา</Alert>
        ) : (
          <TextField
            autoFocus
            fullWidth
            type="number"
            label="ราคาน้ำหนักส่วนเกิน (บาท/กก.)"
            value={price}
            onChange={(event) => setPrice(event.target.value)}
            inputProps={{ min: 0, step: "any" }}
            error={price !== "" && !valid}
            helperText={price !== "" && !valid ? "กรุณาระบุราคาเป็นตัวเลขตั้งแต่ 0 ขึ้นไป" : ""}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ยกเลิก</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!valid || details.extraWeight <= 0}
        >
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
}
